export default __webpack_public_path__ + "static/logo_condusef_claro-630aa126f31fda4834574774593068b3.png";